// Money is integer paise everywhere in the ledger. These helpers are the ONLY
// boundary where rupees-as-text exist: parsing user input and rendering.

const inr = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
});

export function formatPaise(paise: number): string {
  return inr.format(paise / 100);
}

// Plain editable text ("123.45") for input fields and UPI amounts.
export function paiseToInputText(paise: number): string {
  return (paise / 100).toFixed(2);
}

// "123", "123.4", "123.45" -> paise. Integer arithmetic only; rejects a third
// decimal instead of rounding (a silently rounded paisa is a wrong ledger).
export function parseAmountToPaise(input: string): number | null {
  const trimmed = input.trim();
  if (!/^\d{1,10}(\.\d{1,2})?$/.test(trimmed)) return null;
  const [whole = "0", frac = ""] = trimmed.split(".");
  const paise = Number.parseInt(whole, 10) * 100 + Number.parseInt(`${frac}00`.slice(0, 2), 10);
  return paise > 0 ? paise : null;
}

export function buildUpiLink(opts: {
  vpa: string;
  name: string;
  paise: number;
  note: string;
}): string {
  const rupees = paiseToInputText(opts.paise);
  const params = new URLSearchParams();
  params.set("pa", opts.vpa);
  if (opts.name !== "") params.set("pn", opts.name);
  params.set("am", rupees);
  params.set("cu", "INR");
  if (opts.note !== "") params.set("tn", opts.note.slice(0, 60));
  return `upi://pay?${params.toString()}`;
}

export function looksLikeVpa(vpa: string): boolean {
  return /^[a-z0-9][a-z0-9._-]{1,48}@[a-z][a-z0-9]{1,30}$/i.test(vpa);
}
